import { envVars } from '../../helpers';

export const CRISP_WEBSITE_ID = envVars(
  'NEXT_PUBLIC_CRISP_WEBSITE_ID',
  process.env.NEXT_PUBLIC_CRISP_WEBSITE_ID
)
  .required()
  .asString();
